import { render, staticRenderFns } from "./tabs-Transport.vue?vue&type=template&id=7004833a&scoped=true&"
import script from "./tabs-Transport.vue?vue&type=script&lang=js&"
export * from "./tabs-Transport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7004833a",
  null
  
)

export default component.exports